import { render, staticRenderFns } from "./addApp.vue?vue&type=template&id=35cbe7fa&scoped=true&"
import script from "./addApp.vue?vue&type=script&lang=js&"
export * from "./addApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbe7fa",
  null
  
)

export default component.exports